export default async (ms: number) => new Promise(r => setTimeout(r, ms));
